import { useBaseTracker } from "@shapr3d/frontend-lib";

import type TrackingAdapter from "../lib/TrackingAdapter";

const useTracker = useBaseTracker as () => TrackingAdapter;

export default useTracker;
